import {
  INVALID_CAR_NAMES_MANAGEMENT_URL,
  UI_URL
} from '../../constants/constants';

const CACHE_CLEAR_PATH = '/api/cache/clear';

/**
 * Clears the consumer UI cache (e.g. app-data reads) via the UI origin.
 * @param {string} token Firebase ID token
 */
export async function clearCache(token) {
  if (!token) {
    throw new Error('לא מחובר – אין טוקן אימות');
  }
  const base = String(UI_URL || '').replace(/\/$/, '');
  const url = `${base}${CACHE_CLEAR_PATH}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(text || `שגיאת שרת (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res;
}

/**
 * Triggers CDN cache invalidation (Cloud Function) for invalid car names flow.
 * @param {string} token Firebase ID token
 */
export async function invalidateInvalidCarNamesCdn(token) {
  if (!token) {
    throw new Error('לא מחובר – אין טוקן אימות');
  }
  const url = String(INVALID_CAR_NAMES_MANAGEMENT_URL || '').trim();
  if (!url) {
    throw new Error('לא הוגדרה כתובת לביטול מטמון ה-CDN');
  }
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(text || `שגיאת שרת (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res;
}
